<template>
    <div class="clearfix">
        <div v-if="dailyPnl.length === 0">
            Loading...
        </div>
        <div v-else class="badge">

            <span v-for="i in displayedPnl" :key="i.key" :class="decoratePnlClass(i.profitValue)">
                <div v-if="i.profitValue != 0">{{ i.profitValue | number('0,0') }}</div>
                <div v-else style="line-height: 1; vertical-align: middle;">·</div>
            </span>


        </div>
    </div>

</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            portfolioguid: String
        },
        data: function () {
            return {
                dailyPnl: [],
                portfolioGuid: this.portfolioguid,
                noResults: false,
                isMobile: false
            }
        },
        computed: {
            displayedPnl() {
                const limit = this.isMobile ? 15 : 40;
                return this.dailyPnl.slice(0, limit);
            }
        },
        async mounted() {
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
            this.getDailyProfits();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkScreenSize);
        },
        methods: {
            checkScreenSize() {
                this.isMobile = window.innerWidth < 768;
            },
            decoratePnlClass: function (s) {
                return "badge badge-pill " + (parseFloat(s) < 0.0 ? "badge-danger" : "badge-dark");
            },
            async getDailyProfits() {

                const { data } = await axios.get('/api/trades/GetPnLGraphData', {
                    params: {
                        portfolioGuid: this.portfolioGuid,
                        security: null,
                        fromDate: "2022-01-02", //NOT BEING USED ANYWAYS
                        dateRangeId: 3,
                        marketId: 1
                    }
                });

                this.dailyPnl = data;
            }
        }
    }
</script>
